import { useState } from "react";
import Layout from "../components/layout";
import {GetStaticProps} from "next";
import {Polygon, PolygonOuter} from "../components/v2/icons";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../next-i18next.config";
import "../styles/scss/yc-deal.module.scss";

const YcDeal = () => {
    let isValidInputs = true;
    const [fullname, setFullname] = useState("");
    const [fullnameErr, setFullnameErr] = useState(false);
    const [lastName, setLastName] = useState("");
    const [lastNameErr, setLastNameErr] = useState(false);
    const [email, setEmail] = useState("");
    const [emailErr, setEmailErr] = useState(false);
    const [subject, setSubject] = useState("");
    const [subjectErr, setSubjectErr] = useState(false);
    const [message, setMessage] = useState("");
    const [messageErr, setMessageErr] = useState(false);
    const [ycBatch, setYcBatch] = useState("");
    const [querySent, setQuerySent] = useState(false);
    const [querySentText, setQuerySentText] = useState(
        "Thanks for reaching out! We will look over your message and get back to you soon"
    );
    const [isLoading, setIsLoading] = useState(false);
    const [ycBatchErr, setYcBatchErr] = useState(false);
    const handleSubmit = (e) => {
        e.preventDefault();
        validateInputs();
        if (isValidInputs) {
            setIsLoading(true);
            var xhr = new XMLHttpRequest();
            var url =
                "https://api.hsforms.com/submissions/v3/integration/submit/25310090/47a8b878-8248-4fb9-8c66-4612f68d7563";
            var data = {
                submittedAt: Date.now(),
                fields: [
                    {
                        name: "firstname",
                        value: fullname,
                    },
                    {
                        name: "lastname",
                        value: lastName,
                    },
                    {
                        name: "email",
                        value: email,
                    },
                    // {
                    //     name: "phone",
                    //     value: phone,
                    // },
                    {
                        name: "company",
                        value: subject,
                    },
                    {
                        name: "message",
                        value: message,
                    },
                    {
                        name: "yc_batch",
                        value: ycBatch,
                    },
                    {
                        name: "source_type",
                        value: "yc-onboarding",
                    },
                ],
                context: {
                    pageUri: "https://middleware.io/yc-onboarding",
                    pageName: "YC Onboarding",
                },
            };
            var final_data = JSON.stringify(data);
            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.onreadystatechange = function () {
                setIsLoading(false);
                if (xhr.readyState == 4 && xhr.status == 200) {
                    setEmail("");
                    setFullname("");
                    // setPhone('')
                    setSubject("");
                    setMessage("");
                    // setMessage('')
                    setLastName("");
                    setYcBatch("");
                    setQuerySent(true);
                    setTimeout(() => {
                        setQuerySent(false);
                    }, 6000);
                    // Returns a 200 response if the submission is successful.
                } else if (xhr.readyState == 4 && xhr.status == 400) {
                    setQuerySentText(xhr.responseText);
                } else if (xhr.readyState == 4 && xhr.status == 403) {
                    setQuerySentText(xhr.responseText);
                }
            };
            xhr.send(final_data);
        }
    };
    const validateInputs = () => {
        const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const phoneRegEx =
            /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        // const emailRegEx =
        //   /^([\w-\.]+@(?!gmail.com)(?!yahoo.com)(?!hotmail.com)(?!yahoo.co.in)(?!aol.com)(?!abc.com)(?!xyz.com)(?!pqr.com)(?!rediffmail.com)(?!live.com)(?!outlook.com)(?!me.com)(?!msn.com)(?!ymail.com)([\w-]+\.)+[\w-]{2,4})?$/;

        let emailId = email;
        let isInvalidEmail =
            emailId.length < 2 || !emailRegEx.test(String(emailId).toLowerCase());
        let isInvalidName = fullname.length < 1;
        // let isInvalidPhone = phone.length < 1 || !phoneRegEx.test((phone).toLowerCase())
        let isInvalidSubject = subject.length < 1;
        let isInvalidMessage = message.length < 3;
        let isInvalidLastName = lastName.length < 1;
        let isInvalidYcBatch = ycBatch.length < 1

        if (isInvalidEmail) {
            setEmailErr(true);
        }
        if (isInvalidName) {
            setFullnameErr(true);
        }
        if (isInvalidLastName) {
            setLastNameErr(true);
        }

        // if(isInvalidPhone){
        //     setPhoneErr(true)
        // }
        if (isInvalidSubject) {
            setSubjectErr(true);
        }
        if (isInvalidMessage) {
            setMessageErr(true);
        }
        if (isInvalidYcBatch) {
            setYcBatchErr(true);
        }
        isValidInputs =
            !isInvalidEmail &&
            !isInvalidName &&
            !isInvalidSubject &&
            !isInvalidMessage &&
            !isInvalidLastName && !isInvalidYcBatch;
    };
    return (
        <>
            <Layout
                isHomePage={false}
                pageTitle={"Middleware's Exclusive Y Combinator Offer"}
                ogImage={"/images/v2/YC Deal OG.png"}
                uri={"/yc-onboarding/"}
                metaTitle={"Middleware's Exclusive Y Combinator Offer"}
                metaDesc={"Take advantage of Middleware’s exclusive Y Combinator deal for current batch members and alumni. Get up to $25,000 in credits, 50% off for 3 years, dedicated support, and more. Apply now!"}
                metaRobotsNoindex={"index"}
                metaRobotsNofollow={"follow"}
            >
                <div className={"global-wrapper yc-onboarding"}>
                    <section className="yc-hero-section">
                        <div className="container">
                            <div className="yc-inner-container">
                                <div className="d-flex">
                                    <div className="left-block">
                                        <h1>
                                            Our exclusive{" "}
                                            <span className="gradient-line">Y Combinator</span> offer
                                            awaits
                                        </h1>
                                        <p>
                                            We offer special benefits for teams in the current batch
                                            as well as alumni of YC.
                                        </p>
                                    </div>
                                    <div className="right-block">
                                        <img
                                            src={"/images/yc-deal/yc-deal-hero.svg"}
                                            alt={"Middleware YC deal"}
                                            width={"100%"}
                                            height={"100%"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="features yc-features">
                        <div className="container">
                            <div className="d-flex">
                                <div className="feature-block title-block">
                  <span className="small-title">
                    <span>
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                      >
                        <rect
                            width="20"
                            height="20"
                            rx="2.77778"
                            fill="#FB651E"
                        />
                        <path
                            d="M9.21617 11.8455L5 4H6.92685L9.40695 8.96502C9.44511 9.05345 9.48962 9.14504 9.54049 9.2398C9.59137 9.33455 9.63588 9.43246 9.67404 9.53353C9.69947 9.57143 9.71855 9.60617 9.73127 9.63776C9.74399 9.66934 9.75671 9.69777 9.76943 9.72303C9.83302 9.84937 9.89025 9.97255 9.94112 10.0926C9.992 10.2126 10.0365 10.3231 10.0747 10.4242C10.1764 10.2094 10.2877 9.97886 10.4085 9.73251C10.5294 9.48615 10.6534 9.23032 10.7805 8.96502L13.2988 4H15.0921L10.8378 11.9402V17H9.21617V11.8455Z"
                            fill="white"
                        />
                      </svg>
                    </span>
                    YC Deal
                  </span>
                                    <h2>
                                        <span className="gradient">Benefits</span> for Both Current
                                        Batch & Alumni{" "}
                                    </h2>
                                </div>
                                <div className="feature-block">
                                    <h5>
                                        $25,000 <span>Credit (first 12 months)</span>
                                    </h5>
                                    <p className="feature-desc">
                                        Enough Credit to Cover All Startup Workloads Comfortably
                                    </p>
                                    <div className="feature-tag primary-tag">
                                        W24, S24 Batch Exclusive
                                    </div>
                                </div>
                                <div className="feature-block">
                                    <h5>
                                        50% Off <span>(3 years)</span>
                                    </h5>
                                    <p className="feature-desc">
                                        Of{" "}
                                        <a target="_blank" href="https://middleware.io/pricing/">
                                            Our Pricing plan
                                        </a>{" "}
                                        Which Totals 50-70% Less Than Our Competitors
                                    </p>
                                    <div className="feature-tag success-tag">
                                        YC Alumni Exclusive
                                    </div>
                                </div>
                                <div className="feature-block">
                                    <p className="feature-desc">
                                        Assigned <span>Onboarding Engineer</span> and Direct Line to
                                        the Founders
                                    </p>
                                </div>
                                <div className="feature-block">
                                    <p className="feature-desc">
                                        Dedicated <span>Slack Channel</span> for Support and Direct
                                        Access to Engineering
                                    </p>
                                </div>
                                <div className="feature-block">
                                    <p className="feature-desc">
                                        Middleware <span>Swag</span> (Of course!)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="apply-for-yc-deal">
                        <div className="container">
                            <div className="yc-inner-container">
                                <div className="d-flex">
                                    <div className="left-block">
                                        <h3>
                                            How to <span className="gradient-span">Apply</span>
                                        </h3>
                                        <div className="steps-wrapper">
                                            <div className="step">
                                                <div className="step-number">
                                                    <div className="polygon-outer">
                                                        <PolygonOuter />
                                                        <div className="polygon-inner">
                                                            <Polygon />
                                                        </div>
                                                        <span className="number">1</span>
                                                    </div>
                                                </div>
                                                <div className="step-name">
                                                    Sign up for{" "}
                                                    <a
                                                        target="_blank"
                                                        href="https://app.middleware.io/auth/register/"
                                                    >
                                                        Middleware
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="step">
                                                <div className="step-number">
                                                    <div className="polygon-outer">
                                                        <PolygonOuter />
                                                        <div className="polygon-inner">
                                                            <Polygon />
                                                        </div>
                                                        <span className="number">2</span>
                                                    </div>
                                                </div>
                                                <div className="step-name">Complete the Form </div>
                                            </div>
                                            <div className="step">
                                                <div className="step-number">
                                                    <div className="polygon-outer">
                                                        <PolygonOuter />
                                                        <div className="polygon-inner">
                                                            <Polygon />
                                                        </div>
                                                        <span className="number">3</span>
                                                    </div>
                                                </div>
                                                <div className="step-name">
                                                    Update the{" "}
                                                    <a
                                                        target="_blank"
                                                        href="https://app.middleware.io/settings/billing"
                                                    >
                                                        Billing Details
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right-block">
                                        <div className="form-area">
                                            <form onSubmit={(e) => handleSubmit(e)}>
                                                <div className={"d-flex"}>
                                                    <div className={"input-wrapper"}>
                                                        <label>First Name</label>
                                                        <br />
                                                        <input
                                                            type={"text"}
                                                            value={fullname}
                                                            placeholder={"First name"}
                                                            className={`${
                                                                fullnameErr
                                                                    ? "is-error contact-input"
                                                                    : "contact-input"
                                                            }`}
                                                            onChange={(e) => {
                                                                const value = e.target && e.target.value;
                                                                setFullname(value);
                                                            }}
                                                            onKeyUp={(e) => {
                                                                if (fullname.length > 0) {
                                                                    setFullnameErr(false);
                                                                }
                                                            }}
                                                        />
                                                        <h6
                                                            className={`form-input-validation ${
                                                                fullnameErr ? "error" : ""
                                                            }`}
                                                        >
                                                            First name is required
                                                        </h6>
                                                    </div>
                                                    <div className={"input-wrapper"}>
                                                        <label>Last Name</label>
                                                        <br />
                                                        <input
                                                            type={"text"}
                                                            value={lastName}
                                                            placeholder={"Last name"}
                                                            className={`${
                                                                fullnameErr
                                                                    ? "is-error contact-input"
                                                                    : "contact-input"
                                                            }`}
                                                            onChange={(e) => {
                                                                const value = e.target && e.target.value;
                                                                setLastName(value);
                                                            }}
                                                            onKeyUp={(e) => {
                                                                if (fullname.length > 0) {
                                                                    setLastNameErr(false);
                                                                }
                                                            }}
                                                        />
                                                        <h6
                                                            className={`form-input-validation ${
                                                                lastNameErr ? "error" : ""
                                                            }`}
                                                        >
                                                            Last name is required
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div className={"input-wrapper"}>
                                                    <label>Email</label>
                                                    <br />
                                                    <input
                                                        type={"text"}
                                                        value={email}
                                                        placeholder={"Enter email"}
                                                        className={`${
                                                            emailErr
                                                                ? "is-error contact-input"
                                                                : "contact-input"
                                                        }`}
                                                        onChange={(e) => {
                                                            const value = e.target && e.target.value;
                                                            setEmail(value);

                                                        }}
                                                        onKeyUp={(e) => {
                                                            if (email.length > 0) {
                                                                setEmailErr(false);
                                                            }
                                                        }}
                                                    />
                                                    <h6
                                                        className={`form-input-validation ${
                                                            emailErr ? "error" : ""
                                                        }`}
                                                    >
                                                        {email.length < 1
                                                            ? "Email is required"
                                                            : "Please enter valid email address"}
                                                    </h6>
                                                </div>
                                                <div className={"input-wrapper"}>
                                                    <label>Company Name</label>
                                                    <br />
                                                    <input
                                                        type={"text"}
                                                        value={subject}
                                                        placeholder={"Company name"}
                                                        className={`${
                                                            subjectErr
                                                                ? "is-error contact-input"
                                                                : "contact-input"
                                                        }`}
                                                        onChange={(e) => {
                                                            const value = e.target && e.target.value;
                                                            setSubject(value);
                                                        }}
                                                        onKeyUp={(e) => {
                                                            if (subject.length > 0) {
                                                                setSubjectErr(false);
                                                            }
                                                        }}
                                                    />
                                                    <h6
                                                        className={`form-input-validation ${
                                                            subjectErr ? "error" : ""
                                                        }`}
                                                    >
                                                        Company name is required
                                                    </h6>
                                                </div>
                                                <div className="input-wrapper">
                                                    <label>Which YC Batch are you?</label>
                                                    <div>


                                                        <input
                                                            type={"text"}
                                                            value={ycBatch}
                                                            placeholder={"Which YC Batch are you?"}
                                                            className={`${
                                                                ycBatchErr
                                                                    ? "is-error contact-input"
                                                                    : "contact-input"
                                                            }`}
                                                            onChange={(e) => {
                                                                const value = e.target && e.target.value;
                                                                setYcBatch(value);

                                                            }}
                                                            onKeyUp={(e) => {
                                                                if (email.length > 0) {
                                                                    setYcBatchErr(false);
                                                                }
                                                            }}
                                                        />
                                                        <h6
                                                            className={`form-input-validation ${
                                                                ycBatchErr ? "error" : ""
                                                            }`}
                                                        >
                                                            YC Batch is required
                                                        </h6>
                                                    </div>

                                                </div>


                                                <div className={"input-wrapper"}>
                                                    <div className={""}>
                                                        <label>Give us more detail</label>
                                                        <br />
                                                        <textarea
                                                            value={message}
                                                            rows={5}
                                                            placeholder={
                                                                "Tell us more about your goals with Middleware"
                                                            }
                                                            className={`${
                                                                messageErr
                                                                    ? "is-error contact-input"
                                                                    : "contact-input"
                                                            }`}
                                                            onChange={(e) => {
                                                                const value = e.target && e.target.value;
                                                                setMessage(value);
                                                            }}
                                                            onKeyUp={(e) => {
                                                                if (message.length > 0) {
                                                                    setMessageErr(false);
                                                                }
                                                            }}
                                                        />
                                                        <h6
                                                            className={`form-input-validation ${
                                                                messageErr ? "error" : ""
                                                            }`}
                                                        >
                                                            Minimum 3 characters required
                                                        </h6>
                                                    </div>
                                                </div>

                                                <button type={"submit"} className={"primary"}>
                                                    {isLoading ? "Loading..." : "Apply Now"}
                                                </button>
                                                {querySent && (
                                                    <h6
                                                        className={`form-input-validation ${
                                                            querySent ? "success" : "error"
                                                        }`}
                                                    >
                                                        {querySentText}
                                                    </h6>
                                                )}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div className="note-section">
                                    <p>
                                        After completing all the above steps, benefits will be
                                        applied automatically to your account.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </Layout>
        </>
    );
};
export const getStaticProps: GetStaticProps = async ({ locale }) => {

    return {
        props: {
            pageData: "",
            pageTitle: "Middleware's Exclusive Y Combinator Offer",
            description: "Take advantage of Middleware’s exclusive Y Combinator deal for current batch members and alumni. Get up to $25,000 in credits, 50% off for 3 years, dedicated support, and more. Apply now!",
            ogImage: "/images/YC Deal OG.png",
            uri: "/yc-onboarding/",
            metaTitle: "Middleware's Exclusive Y Combinator Offer",
            metaDesc: "Take advantage of Middleware’s exclusive Y Combinator deal for current batch members and alumni. Get up to $25,000 in credits, 50% off for 3 years, dedicated support, and more. Apply now!",
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
            ...(await serverSideTranslations(locale ?? 'en', ['common', 'header', 'footer'], nextI18NextConfig)),
        },
    }
}

export default YcDeal;